import React from 'react';
import { Task } from 'shared/types/task';
import { formatDateKey } from 'shared/utils/format-date-key';

import { UpcomingWeek } from '../upcoming-week';
import * as Styled from './upcoming.style';
import { useUpcomingWeeks } from './use-upcoming-weeks';

export type UpcomingProps = {
  task: Task;
};

export const Upcoming: React.FC<UpcomingProps> = ({ task }) => {
  const weeks = useUpcomingWeeks(task);

  return (
    <Styled.List>
      {weeks.map((week) => (
        <Styled.ListItem key={formatDateKey(week.date)}>
          <UpcomingWeek task={task} week={week} />
        </Styled.ListItem>
      ))}
    </Styled.List>
  );
};
